import { Box, Typography, Skeleton } from "@mui/material";
import { useEffect } from "react";
import TakeoutSalesDataGrid from "../Component/DataGrid/TakeoutSalesDataGrid";
import { SalesRepository } from "../DAL/repositories/SalesRepository";
import { ResourceOperation, useApplicationStore } from "../provider/ApplicationStoreProvider";

export const TakeoutSalesPage = () => {
  const { state, dispatch } = useApplicationStore();
  useEffect(() => {
    if (state.takeoutSales === null) {
      SalesRepository().fetchTakeoutSales().then((result)=>{
        console.log(result)
        dispatch({
          type: ResourceOperation.FETCH_TAKEOUT_SALES,
          payload: result
        })
      });
    }
  }, []);
  return (
    <Box>
      <Typography color="inherit" variant="h2" fontWeight={600} mb={2}>
        売上
      </Typography>
      <Box>
        {state.takeoutSales !== null ? (
          <TakeoutSalesDataGrid />
        ) : (
          <>
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
            <Skeleton animation="wave" />
          </>
        )}
      </Box>
    </Box>
  );
};
